import { ListView } from "@/services/list-view";
import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface SaveAsViewModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    view: ListView;
    onViewChange: (view: ListView) => void;
}

export function SaveAsViewModal({ open, onOpenChange, view, onViewChange }: SaveAsViewModalProps) {
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open && view) {
            setName(view.name + " (Copy)");
        }
    }, [open, view]);

    const handleSave = async () => {
        if (!name.trim()) return;

        setLoading(true);
        try {
            await onViewChange({ ...view, name: name.trim() });
            onOpenChange(false);
        } catch (error) {
            console.error("Error saving view:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Save View As</DialogTitle>
                    <DialogDescription>Create a copy of "{view.name}" with a new name. This will preserve all the current filters, columns, and sorting.</DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="name" className="text-right">
                            New Name
                        </Label>
                        <div className="col-span-3">
                            <Input id="name" value={name} onChange={e => setName(e.target.value)} className="w-full" placeholder="Enter new view name" disabled={loading} />
                        </div>
                    </div>
                </div>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
                        Cancel
                    </Button>
                    <Button onClick={handleSave} disabled={loading || !name.trim()}>
                        {loading ? "Saving..." : "Save As"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
